import { styled } from "styled-components";

const Centering = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ButtonCentering = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Button = styled(ButtonCentering)`
  max-height: 4rem;
  line-height: 2rem;
  font-size: 1.4rem;
  border-radius: 10px;
  cursor: pointer;
  font-weight: 800;
`;

const Card = styled(Centering)`
  flex-direction: row;
  padding: 1vw;
  border-radius: 13px;
  box-shadow: 0 6px 6px 0 gray;
`;

const Input = styled.input`
  font-size: 1.4rem;
  border-radius: 5px;
  border: 2px solid black;
  outline: none;
  &:focus {
    border: #6597f1 solid 3px;
  }
`;

export { Button, ButtonCentering, Card, Centering, Input };

